import { getDocuments } from '../services/documents';

const getAuditLog = async ({
  actionType,
  fromDate,
  toDate,
  page,
  size,
}: {
  actionType?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  size?: number;
}): Promise<any> => {
  const params = new URLSearchParams();
  if (actionType) params.append('actionType', actionType);
  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  if (page != null) params.append('page', String(page));
  if (size != null) params.append('size', String(size));

  return getDocuments(`audit-log?${params.toString()}`);
};

const getAuditLogTypes = async (): Promise<any> => getDocuments('audit-log/types');

export { getAuditLog, getAuditLogTypes };
